<ng-template>
  <div
    class="atx-dropdown-menu"
    [ngClass]="extraClasses"
    @dropdownSlide
    (@dropdownSlide.done)="onAnimationEvent($event)"
    (mouseenter)="setMouseState(true)"
    (mouseleave)="setMouseState(false)"
    data-e2e="dropdown-menu"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
